export const hash = 'f17f3400-77f1-11ec-920b-16b38c2c4059';

// export const gateKey = '';
export const gateKey = '';
export const recaptchaKey = '6LdKIrgZAAAAAFCgNLBhpQNO_a29D30zbLGQx9mb';
export const apiUrl = `https://api-global.encontrodigital.com.br/${hash}`;
export const apiSocket = 'https://global-socket.encontrodigital.com.br/';
//export const apiSocket = 'http://localhost:8001';
//export const apiUrl = `http://localhost:8000/${hash}`;
export const urlWebsite = 'https://confies.encontrodigital.com.br';
export const supportNumber = `5551981476007`;
export const home = 'Home';
// export const urlWebsite = 'http://localhost:3000';



export const config = {
  menu : {
    language : 1,
    directChat : 1
  }
}
export const dadosOrganizacao = 'SEMINÁRIO MAIS BRASIL';
export const eventName = 'SEMINÁRIO MAIS BRASIL';
export const logo = '/assets/evento/logo.png';
export const background = '/assets/evento/Fundo.jpeg';
export const authTitle = 'SEMINÁRIO MAIS BRASIL';
export const social = {
  whatsapp: '',
  instagram: '',
  facebook: '',
  linkedin: '',
  youtube: '',
  twitter: '',
};

export const defaultTheme = {
  defaultBackground: 'rgb(58,128,79)',
  defaultColor: '#fff',
  lightColor:  '#fff',
  logo: {
    minWidth: '450px',
  },
  menu: {
    background: 'none',
    backgroundSticky: 'none',
    backgroundMobile: 'rgb(58,128,79)',
    color: '#fff',
    shadow: '0',
    logoColor: 'none',
  },
};

export const getToken = (): string | null => {
  const token = localStorage.getItem(`@${authTitle}:token`);
  return token;
};
